<template>
  <!-- 견적 요청서 내용 -->
  <div>
    <admin-box-item title="주문 내역" :useTab="false">
      <div class="columns is-multiline" v-if="value">
        <div class="column is-full">
          <table class="table">
            <tr><th>신청자명</th><th>주문 요청일</th><th>연락처</th><th>이메일</th></tr>
            <tr>
              <td>{{ value.name }}</td>
              <td>{{ value.created_time }}</td>
              <td>{{ value.phone }}</td>
              <td>{{ value.email }}</td>
            </tr>
          </table>
        </div>
        <div class="column is-full">
          <admin-form-item class="form-item">
            <div class="flex-between bid-total-price">
              <div>총 금액</div>
              <div>{{ value.price | currency}}</div>
            </div>
            <div :key="'bid'+idx" v-for="(item, idx) in value.price_info" class="flex-between bid-price-info">
              <div>{{ item.note }}</div>
              <div style="text-align: right">
                <div style="font-size: 15px;color:#777">{{ item.price | currency }}</div>
                <div>({{ item.unit_price | currency }}X{{ item.quantity }})</div>
              </div>
            </div>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";

  export default {
    props: ['data'],
    components: {
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: undefined
      }
    },
    computed: {},
    created() {
      this.value = this.data;
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {}
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .lp-estimate-qna
    margin-bottom 12px

  .lp-estimate-qna:last-child
    margin-bottom 0

  .form-item
    overflow-y auto
    /*height calc(100% - 150px)*/
    height 250px
    border 1px solid #ddd
    padding 20px
  .bid-total-price
    font-weight bold
    color #000
    font-size 16px
    border-bottom 1px solid #ddd
    padding-bottom 10px
    margin-bottom 16px
  .bid-price-info
    color #999999
    font-weight bold
    margin-bottom 16px

</style>

<style lang="stylus">
  .v--modal-overlay .v--modal-box
    max-height 90vh
</style>
